import React, { useState } from "react";
import Select from "react-select";

function Advancedfilter({ categories, subCategories, setParentFilters, filters: parentFilters }) {
  const [filters, setFilters] = useState({
    categoryId: parentFilters?.categoryId || "",
    steering: "",
    bodyType: "",
    transmission: "",
    transmissionType: "",
    modification: "",
    engine: "",
    engineCode: "",
    grade: "",
    subcategoryId: "",
    subCategoryId: "",
  });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderRadius: "6px",
      borderColor: "#ced4da",
      marginBottom: "10px",
      fontSize: "14px",
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };

  const clearFilters = () => {
    const reset = { categoryId: "",
      steering: "",
      bodyType: "",
      transmission: "",
      transmissionType: "",
      modification: "",
      engine: "",
      engineCode: "",
      grade: "",
      subcategoryId: "",
      subCategoryId: "",
    };

    setFilters(reset);
    setParentFilters(reset);
  };

  const handleSelectChange = (name, selectedOption) => {
    const val = selectedOption ? selectedOption.value : "";
    let updated = { ...filters, [name]: val };
    if (name === "transmission") {
      updated.transmissionType = val;
    }
    if (name === "subcategoryId") {
      updated.subCategoryId = val;
    }
    setFilters(updated);
    setParentFilters(updated);
  };

  const categoryOptions = (categories || [])
    .filter((c) => !c.type || (Array.isArray(c.type) ? c.type.includes("spare") : c.type === "spare"))
    .map((cat) => ({
    value: cat._id,
    label: cat.name,
  }));

  const subCategoryOptions = (subCategories || []).map((sub) => ({
    value: sub._id,
    label: sub.name,
  }));

  const steeringOptions = [
    { value: "power steering", label: "Power Steering" },
    { value: "speed-sensitive steering", label: "Speed-Sensitive Steering" },
    { value: "four-wheel steering", label: "Four-Wheel Steering" },
  ];

  const bodyTypeOptions = [
    { value: "hatchback", label: "Hatchback" },
    { value: "sedan", label: "Sedan" },
    { value: "MUV-SUV", label: "MUV-SUV" },
  ];

  const transmissionOptions = [
    { value: "automatic", label: "Automatic" },
    { value: "manual", label: "Manual" },
  ];

  const modificationOptions = [
    { value: "GXE10-AEPVK", label: "GXE10-AEPVK" },
    { value: "JCE15W-AWPVF", label: "JCE15W-AWPVF" },
    { value: "SXE10-AEAVF", label: "SXE10-AEAVF" },
  ];

  const engineOptions = [
    { value: "flat engine", label: "Flat Engine" },
    { value: "v-engine", label: "V-Engine" },
    { value: "twin-cylinder", label: "Twin-Cylinder" },
  ];

  const engineCodeOptions = [
    { value: "P1234", label: "P1234" },
    { value: "P6345", label: "P6345" },
    { value: "P0987", label: "P0987" },
  ];

  const gradeOptions = [
    { value: "grade1", label: "Grade 1" },
    { value: "grade2", label: "Grade 2" },
    { value: "grade3", label: "Grade 3" },
  ];

  return (
    <div className="advanced-filter-wrapper">
      <h6 className="mb-4">Advanced search</h6>

      <button
        type="button"
        className="btn btn-sm btn-outline-danger w-100 mb-3 fw-bold"
        onClick={clearFilters}
      >
        ✕ Clear Filters
      </button>

      {categories?.length > 0 && (
        <div className="mb-2">
          <Select
            isClearable
            isSearchable
            placeholder="Category..."
            options={categoryOptions}
            value={
              categoryOptions.find(
                (opt) => opt.value === filters.categoryId
              ) || null
            }
            onChange={(opt) => handleSelectChange("categoryId", opt)}
            styles={customSelectStyles}
          />
        </div>
      )}

      {subCategories?.length > 0 && (
        <div className="mb-2">
          <Select
            isClearable
            isSearchable
            placeholder="Subcategory..."
            options={subCategoryOptions}
            value={
              subCategoryOptions.find(
                (opt) => opt.value === filters.subcategoryId
              ) || null
            }
            onChange={(opt) => handleSelectChange("subcategoryId", opt)}
            styles={customSelectStyles}
          />
        </div>
      )}

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Steering..."
          options={steeringOptions}
          value={
            steeringOptions.find((opt) => opt.value === filters.steering) || null
          }
          onChange={(opt) => handleSelectChange("steering", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Body Type..."
          options={bodyTypeOptions}
          value={
            bodyTypeOptions.find((opt) => opt.value === filters.bodyType) || null
          }
          onChange={(opt) => handleSelectChange("bodyType", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Transmission..."
          options={transmissionOptions}
          value={
            transmissionOptions.find(
              (opt) => opt.value === filters.transmission
            ) || null
          }
          onChange={(opt) => handleSelectChange("transmission", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Modification..."
          options={modificationOptions}
          value={
            modificationOptions.find(
              (opt) => opt.value === filters.modification
            ) || null
          }
          onChange={(opt) => handleSelectChange("modification", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Engine..."
          options={engineOptions}
          value={
            engineOptions.find((opt) => opt.value === filters.engine) || null
          }
          onChange={(opt) => handleSelectChange("engine", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Engine Code..."
          options={engineCodeOptions}
          value={
            engineCodeOptions.find(
              (opt) => opt.value === filters.engineCode
            ) || null
          }
          onChange={(opt) => handleSelectChange("engineCode", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Grade..."
          options={gradeOptions}
          value={
            gradeOptions.find((opt) => opt.value === filters.grade) || null
          }
          onChange={(opt) => handleSelectChange("grade", opt)}
          styles={customSelectStyles}
        />
      </div>
    </div>
  );
}

export default Advancedfilter;
